interface SvgProps {
  fill?: string;
}

const LightningSvg = ({ fill = '#8277F8' }: SvgProps) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1561_100863)">
      <path
        d="M7.5 1.25L6.75 5L9.75 6.125L4.5 11.75L5.25 8L2.25 6.875L7.5 1.25Z"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1561_100863">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default LightningSvg;
